"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import "./AmenitiesSection.css";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
export default function AmenitiesSection({ projectDetail }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  const amenities = projectDetail?.amenities_data || [];

  const preview = amenities.slice(0, 5);

  const image = projectDetail?.amenities_images?.[0]?.image;
  const scaleFadeVariant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };
  const getImage = (url, w, h) => {
    if (!url) return "";

    const sep = url.includes("?") ? "&" : "?";

    return `${url}${sep}w=${w}&h=${h}`;
  };

  if (!amenities.length) return null;

  const { scrollYProgress } = useScroll();

  const imageY = useTransform(scrollYProgress, [0, 1], [-60, 60]);

  const smoothY = useSpring(imageY, {
    stiffness: 40,
    damping: 20,
    mass: 1,
  });

  return (
    <>
      <section className="amenities-section section-padding">
        <div className="main-container-fluid">
          <div className="amenities-grid">
            {/* LEFT */}

            <div className="amenities-content">
              <div className="section-title">
                <h2 className="white-color">
                  {projectDetail?.amenities_title}
                </h2>
              </div>

              <div className="inner-flex inner-flex-medium">
                <div className="amenities-preview">
                  {preview.map((item, index) => (
                    <div
                      key={item.amenity_id}
                      className="
                      amenity-row
                    "
                    >
                      <span className="white-color">
                        {String(index + 1).padStart(2, "0")} /
                      </span>

                      <p className="white-color">{item.amenity}</p>
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => setOpen(true)}
                  className="
                reecosys-template-button
              button-style-white-outline
              "
                >
                  <p>View All</p>
                </button>
              </div>
            </div>

            {/* RIGHT */}

            <div className="amenities-image">
              {image && (
                <motion.div
                  className="w100 h100"
                  style={{ y: smoothY }}
                  variants={scaleFadeVariant}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{
                    once: true,
                    amount: 0.3,
                  }}
                >
                  <Image
                    fill
                    alt="amenities"
                    src={getImage(image, 1000, 1400)}
                    className="amenities-img"
                  />
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* POPUP */}

      {open && (
        <div
          className="
 amenities-modal
 "
          onClick={() => setOpen(false)}
        >
          <div
            className="
 amenities-popup
 "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popoup-header-amenities">
              <div className="section-subtitle">
                <h4>Amenities</h4>
              </div>

              <button
                className="
              popup-close
            "
                onClick={() => setOpen(false)}
              >
                ×
              </button>
            </div>

            <div
              className="
              amenities-popup-grid
            "
            >
              {amenities.map((item) => (
                <div
                  key={item.amenity_id}
                  className="
                    popup-item
                  "
                >
                  <img src={item.icon} alt="" />

                  <span>{item.amenity}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
